// Popup functionality
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', function (event) {
    const plusButton = event.target.closest('.quantity__button[name="plus"]');
    if (!plusButton) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = plusButton.getAttribute('data-variant-id');
    if (!variantId) {
      console.error('❌ Variant ID not found');
      return;
    }

    const cartItem = plusButton.closest('.cart-item');
    if (!cartItem) {
      console.error('❌ Cart item not found');
      return;
    }

    // Prevent Shopify's default quantity update
    const quantityInput = cartItem.querySelector('input.quantity__input');
    if (quantityInput) {
      quantityInput.setAttribute('data-prevent-shopify-change', 'true');
    }

    // Extract properties from <dt>/<dd> pairs inside .product-option
    const properties = {};
    cartItem.querySelectorAll('.product-option').forEach((option) => {
      const key = option.querySelector('dt')?.textContent.trim().replace(/:$/, '');
      const value = option.querySelector('dd')?.textContent.trim();
      if (key && value) {
        properties[key] = value;
      }
    });

    // Force new cart line
    properties['_duplicate'] = Date.now();

    // Log what we're sending
    console.log('🛒 Duplicating variant:', variantId);
    console.log('📦 Properties:', properties);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: properties,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log('✅ Duplicate item added:', data);
        location.reload(); // Optional: remove if cart auto-updates
      })
      .catch((err) => console.error('❌ Error adding item:', err));
  });
  // To show info popup
  document.querySelectorAll('.info_icon')?.forEach((element) => {
    element.addEventListener('click', (event) => {
      document.querySelectorAll('.custom_popup_wrap')?.forEach((popup) => {
        document.body.style.overflowY = 'hidden'; // Disable scroll
        popup.style.display = 'flex';
      });
      event.stopPropagation(); // Prevent event bubbling
    });
  });

  // To Close popup when clicking outside `.custom_pp_content` or clicking `.close_custom_pp`
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.custom_popup_wrap')?.forEach((popup) => {
      if (
        event.target.closest('.close_custom_pp') || // Close on cross icon click
        !event.target.closest('.custom_pp_content') // Close on click outside
      ) {
        popup.style.display = 'none';
        document.body.style.overflowY = 'auto'; // Restore original overflow
      }
    });
  });
});


// FAQs accordion section script starts
    var acc = document.getElementsByClassName("landing-accordion");
    for (let i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("current");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        } 
      });
    }

    document.querySelectorAll('.head1').forEach((head) => {
      head.addEventListener('click', function () {
        const group = this.parentElement;
        if (group) {
          group.querySelectorAll('.head1.active').forEach((activeHead) => {
            activeHead.classList.remove('active');
          });
        }
        this.classList.add('active');

        const dot = this.getAttribute('data-box');
        document.querySelectorAll('.landing-acc-box').forEach((box) => {
          box.classList.toggle('active', box.getAttribute('data-box') === dot);
        });
      });
    });
  // FAQs accordion section script ends


   // cart page token js 
 document.addEventListener("DOMContentLoaded", function() {
  // Run only on /cart page
  if (window.location.pathname === "/cart") {
    // Fetch cart JSON from Shopify
    fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
        if (cart && cart.token) {
          // Extract only the part before '?key='
          const cleanToken = cart.token.split("?key=")[0];
          // const cleanToken = cart.token;
          
          // Save it to localStorage (replace if already exists)
          localStorage.setItem("cart_token", cleanToken);
          
          console.log("✅ Cart token saved:", cleanToken);
        } else {
          console.warn("⚠️ No token found in cart JSON.");
        }
      })
      .catch(error => console.error("❌ Error fetching cart JSON:", error));
  }
});
